import { GetPaymnetHistoryByOrgRes, GetPaymnetHistoryReq, OrgPaymentMethodDto } from "../../interfaces";
import { ApiResponse, PagedResults } from "../../interfaces/genericResponse/GenericResponse";
import { apiGet } from "../../utilities/api-client/apiRequest";
import { buildQuery } from "../../utilities/common/buildQueryParams";

export async function getMyOrganizationSubscriptionAsync(
    authToken: string,
    orgId : number | undefined | null = null,
    signal?: AbortSignal
): Promise<ApiResponse<OrgPaymentMethodDto[]>> {
    let apiUrl: string = `/OrgPaymentMethod/org/GetallPaymentMethods`;

    if(orgId){
        apiUrl += `?orgId=${orgId}`
    }

    var res = apiGet<ApiResponse<OrgPaymentMethodDto[]>>(
        apiUrl, authToken, signal
    );
    return res;
}

export async function GetPaymnetHistoryByOrgAsync(
    authToken: string,
    payload: GetPaymnetHistoryReq,
    signal?: AbortSignal
): Promise<ApiResponse<PagedResults<GetPaymnetHistoryByOrgRes>>> {
    const queryString = buildQuery(payload);
    const apiUrl: string = `/OrgPaymentMethod/GetPaymnetHistory?${queryString}`;

    var res = apiGet<ApiResponse<PagedResults<GetPaymnetHistoryByOrgRes>>>(
        apiUrl, authToken, signal
    );
    return res;
}